import React, { useEffect, useState, useRef } from "react";
import {
  Tag,
  Form,
  Col,
  Row,
  Table,
  Layout,
  Upload,
  Descriptions,
  Switch,
  Tabs,
  List,
  Card,
  Collapse,
  Typography,
  message,
  Tooltip,
  Modal,
  Button,
  DatePicker,
  Space,
  Input,
  InputNumber,
  Divider,
  Popconfirm,
} from "antd";

import {
  getHeader,
  getPOA,
  updateAvance,
  updateFecha,
  updatePeso,
  reportarAvance,
  updateAvanceIndividual,
  getPOAvancesIndividuales,
  getPOAInidceAvancesIndividuales,
  eliminarAvanceService,
} from "../../services/plaOperativo/headerPlanOperativoServices";
import {
  VerticalAlignMiddleOutlined,
  ColumnHeightOutlined,
  QuestionCircleOutlined,
  InboxOutlined,
  EyeOutlined,
  TableOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  MenuOutlined,
  MoreOutlined,
  ArrowLeftOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { fetchPoaData } from "../../services/poa/get_poa";
import FileManagerPOA2 from "./FileManagerPP";
import FileManagerPOAN from "./FileManagerPOAN";
import EditableCell from "./EditableCell";

import "./PoaPlanOperativoTable.css";
import moment from "moment";
import dayjs from "dayjs";
import esES from "antd/es/locale/es_ES";

import { selectAppPermissions } from "../../store/auth/selectors.js";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Dragger } = Upload;

const PoaPlanOperativoTB = ({
  selectedFase,
  selectedProject,
  regresarAnterior,
  cerrarModal,
}) => {
  const [headerPO, setHeaderPO] = useState({});
  const [loading, setLoading] = useState(true);
  const [actividades, setActividades] = useState([]);
  const [mapaMesPoa, setMapaMesPoa] = useState({}); //Variable para controlar el mes del POA y el mes del cronograma
  const [error, setError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [actividadSelect, setActividadSelect] = useState(null);
  const [openModal1, setOpenModal1] = useState(false);
  const [itemParams, setItemParams] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isTableView, setIsTableView] = useState(false);

  const [mesInicial2024, setMesInicial2024] = useState("");
  const [mesInicial2025, setMesInicial2025] = useState("");
  const [mesInicial2026, setMesInicial2026] = useState("");

  const [meses2025, setMeses2025] = useState([]);
  const [meses2024, setMeses2024] = useState([]);
  const [meses2026, setMeses2026] = useState([]);

  const [columnasFinales, setColumnasFinales] = useState([]);

  const [tareasSubtareas, setTareasSubtareas] = useState([]);
  const [editingDate, setEditingDate] = useState(false);
  const [isModalVisibleParticipantes, setIsModalVisibleParticipantes] =
    useState(false);
  const [banderaProyecto, setBanderaProyecto] = useState([]);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [valoresJsonPeso, setValoresJsonPeso] = useState([]);
  const [rawPesoData, setRawPesoData] = useState([]);
  const [mostrarTablaCronograma, setMostrarTablaCronograma] = useState(true);
  const [isVisibleTarea, setIsVisibleTarea] = useState(true);
  const [isVisibleTablePO, setIsVisibleTablePO] = useState(true);

  const appName = "poa_plan_operativo";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );

  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;

  const permissionInsert = permissions.priv_insert === "Y"; //Tabla y fecha Actualizacion
  const permissionDelete = permissions.priv_delete === "Y";
  const permissionUpdate = permissions.priv_update === "Y"; //Soportes
  const permissionExport = permissions.priv_export === "Y";
  const permissionView = permissions.priv_print === "Y"; // Peso Prcentual
  const permissionPrint = permissions.priv_print === "Y";

  const [modalVisible, setModalVisible] = useState(false);
  const [current, setCurrent] = useState({
    parent: null,
    mesAno: null,
    advance: null,
  });

  const [submitting, setSubmitting] = useState(false); //Control del envio del fomulario de avances
  const [form] = Form.useForm();

  // Estado adicional en tu componente
  const [isEditing, setIsEditing] = useState(false);
  const [currentAdvance, setCurrentAdvance] = useState(null);
  const [historyList, setHistoryList] = useState([]);
  const [activeTab, setActiveTab] = useState("history");

  const initialSupportRef = useRef({ name: "", ruta: "" });

  useEffect(() => {
    setMesInicial2025("");
    setMesInicial2026("");
    setMeses2025([]);
    setMeses2026([]);
    setColumnasFinales([]);
  }, [selectedProject.oid]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data } = await getHeader(selectedProject.oid);

        setHeaderPO(data?.encabezado[0]);
        setError(false);
      } catch (error) {
        setError(true);
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [selectedProject.oid]);

  const fetchPOA = async () => {
    setLoading(true);
    try {
      // 1) Petición principal
      const { data: poaData } = await getPOA(
        selectedFase.oid,
        selectedProject.oid
      );

      if (!Array.isArray(poaData))
        throw new Error("Los datos de POA no son válidos");

      const mapaMesPoaTemporal = {};

      poaData.forEach((actividad) =>
        actividad.children.forEach((tarea) =>
          tarea.children.forEach((subtarea) => {
            // Buscamos en cronogramasP
            (subtarea.cronogramasP || []).forEach((crono) => {
              if (crono.mes && crono.mes_poa) {
                mapaMesPoaTemporal[crono.mes] = crono.mes_poa;
              }
            });
          })
        )
      );

      // 🔹 Guardar en un estado global para usar en columnas dinámicas
      setMapaMesPoa(mapaMesPoaTemporal);
      // 3) Actualiza meses & actividades
      actualizarMeses(poaData);
      setActividades(poaData);

      // 4) Mapea tus filas “planas”
      const rawRows = mapTareasSubtareas(poaData);

      // 5) **Deriva** aquí mismo tu lista de meses, mesInicial y año
      //    (o usa la misma lógica que usas en actualizarMeses)
      const mesesArray = Array.from(
        new Set(
          poaData.flatMap((act) =>
            act.children.flatMap((t) =>
              t.children.flatMap((s) =>
                (s.cronogramasP || []).map((c) => c.mes)
              )
            )
          )
        )
      );

      const mesInicialVal = mesesArray[0] || "";
      // suponiendo que todos usan el mismo año:
      const anoValor =
        poaData[0]?.children?.[0]?.children?.[0]?.cronogramasP?.[0]?.ano ||
        new Date().getFullYear();

      // 6) Genera tus columnas dinámicas
      const dynCols = generarColumnasDinamicas(
        mesesArray,
        mesInicialVal,
        anoValor
      );
      const mesAnoKeys = dynCols.map((c) => c.dataIndex);

      // 7) Inyecta el flag en cada fila
      const rowsConFlags = rawRows.map((r) => {
        const copia = { ...r };
        mesAnoKeys.forEach((k) => {
          const flagName = `selected_${k}`;
          if (copia[flagName] === undefined) {
            copia[flagName] = false;
          }
        });
        return copia;
      });

      // 8) ¡Guárdalo!
      setTareasSubtareas(rowsConFlags);
    } catch (error) {
      console.error("Error fetching POA:", error);
      setActividades([]);
      setValoresJsonPeso([]);
      setTareasSubtareas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedFase?.oid && selectedProject?.oid) {
      fetchPOA();
    }
  }, [selectedFase.oid, selectedProject.oid]);

  useEffect(() => {
    const columnasCronograma = [];
    setColumnasFinales([]);

    if (meses2024 && meses2024.length > 0 && mesInicial2024) {
      const columnas2024 = generarColumnasDinamicas(
        meses2024,
        mesInicial2024,
        "2024",
        valoresJsonPeso
      );
      if (columnas2024.length > 0) {
        columnasCronograma.push({
          title: "Cronograma 2024",
          className: "color2024",
          children: columnas2024,
        });
      }
    }

    if (meses2025 && meses2025.length > 0 && mesInicial2025) {
      const columnas2025 = generarColumnasDinamicas(
        meses2025,
        mesInicial2025,
        "2025",
        valoresJsonPeso
      );
      if (columnas2025.length > 0) {
        columnasCronograma.push({
          title: "Cronograma",
          className: "color2025",
          children: columnas2025,
        });
      }
    }

    if (meses2026 && meses2026.length > 0 && mesInicial2026) {
      const columnas2026 = generarColumnasDinamicas(
        meses2026,
        mesInicial2026,
        "2026",
        valoresJsonPeso
      );
      if (columnas2026.length > 0) {
        columnasCronograma.push({
          title: "Cronograma 2026",
          className: "color2026",
          children: columnas2026,
        });
      }
    }

    setColumnasFinales(columnasCronograma);
  }, [
    meses2024,
    mesInicial2024,
    meses2025,
    mesInicial2025,
    meses2026,
    mesInicial2026,
    valoresJsonPeso,
  ]);

  function logTotPesoPorMesAnioPorFase(dataJSONPeso) {
    // Objeto que guardará los acumuladores por fase, subdivididos en P y E.
    // Ej: acumuladoresPorFase[faseId] = { P: {}, E: {} }
    const acumuladoresPorFase = {};

    // Recorremos las "fases" (elementos del array dataJSONPeso)
    dataJSONPeso.forEach((fase) => {
      const faseId = fase.fase_id || "fase-sin-id";

      // Si no existe, inicializamos la estructura con P y E vacíos
      if (!acumuladoresPorFase[faseId]) {
        acumuladoresPorFase[faseId] = {
          P: {},
          E: {},
        };
      }

      if (!fase.children) return; // Sin actividades, skip

      fase.children.forEach((tarea) => {
        // Ajusta si tu "pesoPorcentual" es realmente un factor o un %.
        // Aquí supongo que lo usas "tal cual":
        const pesoEntero = parseFloat(tarea.pesoPorcentual) || 0;
        const peso = pesoEntero / 1; // o /100 si en BD 3 significa 3%

        if (!tarea.children) return; // Sin indicadores, skip

        tarea.children.forEach((indicador) => {
          const meta = parseFloat(indicador.meta) || 0;
          if (meta <= 0 || peso <= 0) return; // Evitar /0

          // --- PROYECTADO (P) ---
          if (indicador.cronogramasP) {
            indicador.cronogramasP.forEach((crono) => {
              const p = parseFloat(crono.avance) || 0;
              const mes = crono.mes;
              const ano = crono.ano;
              const keyMesAnio = `${mes}-${ano}`;

              const parcial = (p / meta) * peso;

              if (!acumuladoresPorFase[faseId].P[keyMesAnio]) {
                acumuladoresPorFase[faseId].P[keyMesAnio] = 0;
              }
              acumuladoresPorFase[faseId].P[keyMesAnio] += parcial;
            });
          }

          // --- EJECUTADO (E) ---
          if (indicador.cronogramasP) {
            indicador.cronogramasP.forEach((crono) => {
              const e = parseFloat(crono.avance) || 0;
              const mes = crono.mes;
              const ano = crono.ano;
              const keyMesAnio = `${mes}-${ano}`;

              const parcial = (e / meta) * peso;

              if (!acumuladoresPorFase[faseId].E[keyMesAnio]) {
                acumuladoresPorFase[faseId].E[keyMesAnio] = 0;
              }
              acumuladoresPorFase[faseId].E[keyMesAnio] += parcial;
            });
          }
        });
      });
    });

    // *** REDONDEO AL FINAL ***
    // Recorremos cada fase, y dentro de cada fase, cada tipo (P, E) y cada "mes-año"
    for (const faseId in acumuladoresPorFase) {
      for (const tipo of ["P", "E"]) {
        for (const keyMesAnio in acumuladoresPorFase[faseId][tipo]) {
          const valorAcumulado = acumuladoresPorFase[faseId][tipo][keyMesAnio];
          // Redondear a 2 decimales
          acumuladoresPorFase[faseId][tipo][keyMesAnio] = Number(
            valorAcumulado.toFixed(2)
          );
        }
      }
    }

    // Ahora construimos un objeto JSON con el formato deseado
    // (ej. "fase" y luego "p" y "e" separadas)
    const resultado = { fases: [] };

    for (const [faseId, objPE] of Object.entries(acumuladoresPorFase)) {
      // objPE = { P: {...}, E: {...} }
      resultado.fases.push({
        fase: faseId,
        p: objPE.P,
        e: objPE.E,
      });
    }

    // Devolver el objeto JSON para usarlo en otra parte
    return resultado;
  }

  // 1) Observamos el valor de “fecha” y “observacion” directamente desde el formulario:
  const fechaValue = Form.useWatch("fecha", form);
  const observacionValue = Form.useWatch("observacion", form);

  // 2) Cada vez que cambien fecha/observación/historyList/isEditing o el mesAno, recalculamos soporteName:
  useEffect(() => {
    const generateSoporteName = async () => {
      // 1) Si no hay contexto, limpio y salgo
      if (!current || !current.parent) {
        form.setFieldsValue({ soporteName: "" });
        return;
      }

      // 2) Si estoy en edición, salgo SIN tocar soporteName
      if (isEditing) {
        return;
      }

      // 3) Si faltan fecha u observación, limpio y salgo
      if (!fechaValue || !observacionValue) {
        form.setFieldsValue({ soporteName: "" });
        return;
      }

      // 4) Formateo fecha
      const formattedDate = dayjs(fechaValue).format("YYYY_MM_DD");

      // 5) Llamada al servicio con fallback
      let valorIndice = 1;
      try {
        const resp = await getPOAInidceAvancesIndividuales(
          current.parent.codIndicador
        );
        const { status, data } = resp.data;
        if (status === 200 && Array.isArray(data) && data.length) {
          const apiIndice = data[0].nuevoinidce;
          valorIndice = typeof apiIndice === "number" ? apiIndice + 1 : 1;
        }
      } catch (err) {
        console.error("Error al obtener índice:", err);
        valorIndice = 1;
      }

      // 6) Sanitizo observación
      const obsSanitized = observacionValue
        .trim()
        .replace(/\s+/g, "_")
        .replace(/[^A-Za-z0-9_]/g, "");

      // 7) Construyo y asigno soporteName
      const nuevoSoporteName = `${valorIndice}_${obsSanitized}_${formattedDate}`;
      form.setFieldsValue({ soporteName: nuevoSoporteName });
    };

    generateSoporteName();
  }, [
    fechaValue,
    observacionValue,
    historyList,
    isEditing,
    form,
    current?.mesAno,
  ]);

  // 3) Hook para cargar el historial desde el API cuando entro en la pestaña “history”
  useEffect(() => {
    if (activeTab !== "history") return;
    if (!current || !current.parent) return;

    const indicadorId = current.advance
      ? current.advance.indicador_id
      : current.parent.codIndicador;
    const mesAno = current.mesAno;

    // limpio antes de fetch para evitar datos “pegados”
    setHistoryList([]);

    (async () => {
      try {
        const response = await getPOAvancesIndividuales(indicadorId, mesAno);
        // si no viene array, lo tratamos como vacío
        const avances =
          response.status === 200 && Array.isArray(response.data.data)
            ? response.data.data
            : [];

        setHistoryList(avances);

        // actualizo la tabla principal con la suma de avance_pct
        const sumaTotal = avances.reduce(
          (acc, item) => acc + parseFloat(item.avance_pct || "0"),
          0
        );

        setTareasSubtareas((prev) =>
          prev.map((r) =>
            r.key !== current.parent.key
              ? r
              : {
                  ...r,
                  meta_ejecutada: sumaTotal,
                  [mesAno]: sumaTotal,
                  metaAcu: sumaTotal,
                  [`selected_${mesAno}`]: sumaTotal >= 0.1,
                }
          )
        );
      } catch (err) {
        console.error("Error cargando historial:", err);
        // en caso de error también limpio
        setHistoryList([]);
      }
    })();
  }, [activeTab, current?.parent, current?.mesAno]);

  const toggleVisibilityTarea = () => {
    setIsVisibleTarea(!isVisibleTarea); // Cambiar el estado entre visible y oculto
  };

  const toggleVisibilityTablaPO = () => {
    setIsVisibleTablePO(!isVisibleTablePO);
  };

  const toggleMonth = (rowKey, mesAno, nuevoAvance) => {
    setTareasSubtareas((prev) =>
      prev.map((r) =>
        r.key === rowKey
          ? {
              ...r,
              // marcamos la casilla como “checked”:
              [`selected_${mesAno}`]: true,
              // antes sobrescribíamos, ahora sumamos
              [mesAno]: parseFloat(nuevoAvance),
            }
          : r
      )
    );
  };

  // Funciones de control del modal
  const openForm = (parentRecord, mesAno) => {
    // parentRecord = fila principal de la tabla (tiene codIndicador, proyecto, proyecto_oid, ruta, medioVerificacion, etc.)
    setCurrent({
      parent: parentRecord,
      mesAno,
      advance: null, // todavía no editamos ningún avance histórico
    });

    // Pre-llenamos el “medioVerificación” con lo que trae la fila principal:
    form.resetFields();
    form.setFieldsValue({
      medioVerificacion: parentRecord.medioVerificacion || "",
      observacion: parentRecord.observacion || "",
    });

    setIsEditing(false);
    setActiveTab("form");
    setModalVisible(true);
  };

  // Normaliza el fileList para Form.Item
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  // Cuando el usuario clica “+ Nuevo avance”:
  // Llamado al clicar “+ Nuevo avance”
  const startNew = () => {
    // NO sobrescribimos current.parent ni current.mesAno,
    // ya vinieron del openForm original.
    if (!current || !current.parent || !current.mesAno) {
      return message.error(
        "No hay contexto (fila principal) para crear un nuevo avance."
      );
    }

    setIsEditing(false);
    form.resetFields();
    form.setFieldsValue({
      medioVerificacion: current.parent.medioVerificacion,
      observacion: current.parent.observacion || "",
    });
    setActiveTab("form");
    // El modal ya está abierto; si no, habría que hacer setModalVisible(true) aquí.
  };

  // Llamado al clicar “Editar” en un avance del historial
  // 1) Al hacer clic en “Editar” en el Historial:
  // Llamado al clicar “Editar” en un avance del historial
  const onEdit = (advance) => {
    // Reconstruir mesKey (ej. "mes12025") a partir de advance.mes y advance.ano
    const mesKey = advance.mes.toLowerCase().replace(/\s+/g, "") + advance.ano;

    // 2) Activamos **inmediatamente** el modo edición
    setIsEditing(true);

    // 3) Guardamos en “current” la fila padre y el avance que vamos a editar
    setCurrent((prev) => ({
      parent: prev.parent, // la fila principal
      mesAno: mesKey,
      advance, // objeto con los datos del avance histórico
    }));

    // 4) Limpiamos el formulario antes de asignar nuevos valores
    form.resetFields();

    // 5) Extraer “medioVerificacion” y “soporteName” (baseNameText) desde el JSON
    let medioText = "";
    let baseNameText = "";
    try {
      const parsed = JSON.parse(advance.medio_verificacion);
      medioText = parsed.medioVerificacion || "";
      baseNameText = parsed.soporteName || "";
    } catch (err) {
      console.warn("No se pudo parsear medio_verificación:", err);
    }

    // Si no se obtuvo baseNameText desde JSON, lo extraemos de la ruta del PDF:
    if (!baseNameText && advance.ruta_soporte) {
      const partes = advance.ruta_soporte.split("/");
      const nombreConExt = partes[partes.length - 1]; // "1_Acta_de_Entrega_2025_06_01.pdf"
      baseNameText = nombreConExt.replace(/\.pdf$/i, ""); // "1_Acta_de_Entrega_2025_06_01"
    }

    // 6) Preparamos fileList inicial para <Upload>:
    const fileListInicial = [];
    if (advance.ruta_soporte) {
      fileListInicial.push({
        uid: advance.id.toString(), // UID único
        name: `${baseNameText}.pdf`, // Nombre que veremos en el Upload
        status: "done",
        url: advance.ruta_soporte, // enlace al PDF existente
      });
    }

    // 7) Asignamos todos los campos al formulario **ya en modo edición**:
    form.setFieldsValue({
      // a) fecha: pasamos un moment válido para que DatePicker lo muestre
      fecha: advance.fecha_soporte ? dayjs(advance.fecha_soporte) : null,

      // b) avance: número
      avance: Number(advance.avance_pct),

      // c) medioVerificacion (solo lectura)
      medioVerificacion: medioText,

      // d) “observacion” (campo oculto):
      //    ponemos exactamente el mismo nombre base para que el useEffect NO lo sobrescriba
      observacion: baseNameText,

      // e) soporteName (solo lectura)
      soporteName: baseNameText,

      // f) fileList del Upload
      soporte: fileListInicial,

      // g) observaciones (Textarea)
      observaciones: advance.observaciones || "",
    });

    // 8) Cambiamos a la pestaña “form” dentro del Modal
    setActiveTab("form");
  };

  const onEliminar = async (item) => {
    try {
      const response = await eliminarAvanceService(
        item.id,
        item.ruta_soporte,
        item.indicador_id
      );

      if (response.status === 200) {
        message.success("✅ Avance eliminado correctamente");
        // Esperar un pequeño tiempo antes de refrescar
        setTimeout(() => {
          // refrescar tu tabla o datos si aplica
          setActiveTab("history");
        }, 300);
      } else {
        message.warning("⚠️ No se pudo eliminar el avance, revise la consola");
      }
    } catch (err) {
      console.error("❌ Error llamando al servicio eliminarAvance:", err);
      message.error("❌ Error eliminando el avance");
    }
  };

  // --- Nuevo onFinish unificado: ---
  // 4) onFinish para Guardar/Actualizar
  // Dentro de tu componente de React:

  const onFinish = async (values) => {
    // 1) Siempre debe haber un PDF:
    if (!values.soporte || values.soporte.length === 0) {
      return message.error("Debe cargar un archivo PDF.");
    }

    // 2) Inicializamos FormData y empaquetamos datos comunes:
    const formData = new FormData();
    formData.append("fechaSoporte", values.fecha.format("YYYY-MM-DD"));
    formData.append("avanceReportado", values.avance);
    formData.append("medioVerificacion", values.medioVerificacion);
    formData.append("observaciones", values.observaciones);
    formData.append("soporteName", values.soporteName);
    formData.append("userLogin", userLogin);

    // 2.a) Detectamos si el PDF es nuevo
    const firstFile = values.soporte[0];
    const isNewFile = Boolean(firstFile.originFileObj);

    // 3) Extraemos parent, advance y mesAno del estado “current”
    const { parent, advance, mesAno } = current;

    // 3.a) Ruta antigua: en edición viene en advance, en creación viene en parent
    const oldPath = isEditing ? advance.ruta_soporte : parent.ruta;
    formData.append("rutaSoporte", oldPath);

    if (isEditing) {
      // —————————————————————
      // MODO EDICIÓN de un avance histórico:
      formData.append("avanceId", String(advance.id));
      formData.append("cronograma_id", String(advance.cronograma_id));
      formData.append("indicador_id", String(parent.codIndicador));
      formData.append("oidProyecto", String(parent.proyecto_oid));
      formData.append("codProyecto", String(parent.proyecto));
      formData.append("mesAno", mesAno);

      // 4) Si el usuario cargó un PDF nuevo, pedimos borrar el antiguo y adjuntamos el nuevo
      if (isNewFile) {
        formData.append("deleteOldPath", oldPath);
        formData.append(
          "soporte",
          firstFile.originFileObj,
          `${values.soporteName}.pdf`
        );
      }
      // Si no es nuevo PDF, no adjuntamos nada: backend solo actualizará los metadatos.
    } else {
      // —————————————————————
      // MODO CREACIÓN de un nuevo avance:
      formData.append("indicador_id", String(parent.codIndicador));
      formData.append("mesAno", mesAno);
      formData.append("oidProyecto", String(parent.proyecto_oid));
      formData.append("codProyecto", String(parent.proyecto));

      // En creación siempre adjuntamos el PDF
      formData.append(
        "soporte",
        firstFile.originFileObj,
        `${values.soporteName}.pdf`
      );
    }

    try {
      setSubmitting(true);
      const resp = await reportarAvance(formData);

      if (resp.status === 200 || resp.status === 201) {
        if (!isEditing) {
          // Solo en nueva creación: marco la casilla del mes
          toggleMonth(parent.key, mesAno, values.avance);
        }
        message.success(
          isEditing
            ? "Avance actualizado correctamente."
            : "Avance reportado correctamente."
        );
        form.resetFields();
        setActiveTab("history");
      } else {
        message.error("Error al reportar el avance.");
      }
    } catch (err) {
      console.error("❌ onFinish error:", err);
      message.error("Error de conexión.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    Modal.confirm({
      title: "¿Está segur@ de que desea cerrar?",
      content:
        "Si cierra esta ventana, la información ingresada no se guardará.",
      okText: "Sí, cerrar",
      cancelText: "No",
      onOk: () => {
        setModalVisible(false);
        form.resetFields();
        setIsEditing(false); // <— Muy importante: desactivamos modo edición
      },
    });
  };

  // Tu función sólo genera las columnas, sin el <Modal>
  // 2) Con logs en la generación de columnas dinámicas:
  const generarColumnasDinamicas = (meses = [], mesInicial, ano) => {
    const norm = (s) =>
      String(s || "")
        .toUpperCase()
        .trim();

    // normalizo meses y mesInicial para comparar sin sorpresas
    const mesesNorm = meses.map(norm);
    const miNorm = norm(mesInicial);

    // si no aparece mesInicial, empezamos desde el primer mes
    const start = Math.max(0, mesesNorm.indexOf(miNorm));
    const mesesSlice = mesesNorm.slice(start);

    return mesesSlice.map((mesNorm) => {
      const mesKey =
        mesNorm.toLowerCase().replace(/\s+/g, "") + String(ano).trim();
      const mesPoa = mapaMesPoa?.[mesNorm] || ""; // ej. “MAY”

      return {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>{mesPoa}</div>
            <div style={{ fontSize: "0.75em", color: "#ced4da" }}>
              {mesNorm}
            </div>
          </div>
        ),
        dataIndex: mesKey,
        key: `col_${mesKey}`,
        width: 80,
        align: "center",
        render: (_text, record) => {
          // 1) valor ya hidratado en mapTareasSubtareas (preferente)
          const rawCell = Number(record?.[mesKey] || 0);

          // 2) si faltara, calculo desde cronogramasP de la misma fila
          const sumFromP = (
            Array.isArray(record?.cronogramasP) ? record.cronogramasP : []
          )
            .filter(
              (c) =>
                norm(c.mes) === mesNorm &&
                String(c.ano).trim() === String(ano).trim()
            )
            .reduce((s, c) => s + Number(c?.avance || 0), 0);

          const effective = rawCell > 0 ? rawCell : sumFromP;

          // 3) flags existentes + tolerancia
          const byData = effective >= 0.1;
          const byClick = Boolean(record?.[`selected_${mesKey}`]);
          const checked = byData || byClick;

          return (
            <Tooltip title={checked ? effective.toFixed(1) : ""}>
              <div
                style={{
                  cursor: permissionInsert ? "pointer" : "not-allowed",
                  userSelect: "none",
                  fontSize: "1.2em",
                  color: checked ? "#4CAF50" : "#ddd",
                }}
                onClick={() => {
                  if (!permissionInsert) return;
                  openForm(record, mesKey);
                }}
              >
                {checked ? "✔️" : "—"}
              </div>
            </Tooltip>
          );
        },
      };
    });
  };

  /**
   * Genera un array de meses desde mesInicio hasta mesFin (inclusive),
   * donde los meses vienen como "MES 1", "MES 2", …, "MES 12".
   */
  // arriba del archivo (o en el módulo de helpers)
  const MAX_MONTHS = 20; // si mañana cambia a 18, solo ajustas este valor
  const MONTHS = Array.from({ length: MAX_MONTHS }, (_, i) => `MES ${i + 1}`);

  // Reemplaza tu generarMeses por esta versión dinámica
  const generarMeses = (mesInicio, mesFin) => {
    const mesAIndice = (m) => {
      const match = m.match(/^MES\s+(\d{1,2})$/);
      if (!match) return -1;
      const num = parseInt(match[1], 10);
      return num >= 1 && num <= MONTHS.length ? num - 1 : -1;
    };

    const inicio = mesAIndice(mesInicio);
    const fin = mesAIndice(mesFin);
    if (inicio < 0 || fin < 0) return [];

    if (inicio <= fin) return MONTHS.slice(inicio, fin + 1);
    return [...MONTHS.slice(inicio), ...MONTHS.slice(0, fin + 1)];
  };

  const actualizarMeses = (data) => {
    let encontrado2024 = false;
    let encontrado2025 = false;
    let encontrado2026 = false;

    data.forEach((actividad) => {
      if (encontrado2024 && encontrado2025 && encontrado2026) return;
      actividad.children.forEach((tarea) => {
        if (encontrado2024 && encontrado2025 && encontrado2026) return;
        tarea.children.forEach((item) => {
          if (encontrado2024 && encontrado2025 && encontrado2026) return;
          item.cronogramaconfig.forEach((config) => {
            if (config.anio === "2024" && !encontrado2024) {
              setMesInicial2024(config.mes_inicio);
              setMeses2024(generarMeses(config.mes_inicio, config.mes_final));
              encontrado2024 = true;
            } else if (config.anio === "2025" && !encontrado2025) {
              setMesInicial2025(config.mes_inicio);
              setMeses2025(generarMeses(config.mes_inicio, config.mes_final));
              encontrado2025 = true;
            } else if (config.anio === "2026" && !encontrado2026) {
              setMesInicial2026(config.mes_inicio);
              setMeses2026(generarMeses(config.mes_inicio, config.mes_final));
              encontrado2026 = true;
            }
          });
        });
      });
    });
  };

  const formatDate = (date) => {
    if (!date) return "Sin fecha";

    try {
      const localDate = new Date(date + "T00:00:00"); // Forzar la hora a medianoche
      return localDate.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    } catch {
      return "Formato inválido";
    }
  };

  const handleCancelParticipantes = () => {
    setIsModalVisibleParticipantes(false);
  };

  const handleClickBasedOnURL = (component, record) => {
    procesarMpoa(component, record);
  };

  // mapTareasSubtareas SIN cronogramasE, filtrando P por el indicador actual y acumulando por mes
  const mapTareasSubtareas = (actividades) => {
    return (actividades || []).flatMap((actividad) => {
      if (!actividad?.children?.length) return [];

      return actividad.children.flatMap((tarea) => {
        if (!tarea?.children?.length) return [];

        return tarea.children.map((subtarea) => {
          // 0) SOLO los cronos P del indicador actual (evita mezclar 430/431, etc.)
          const cronoP = (subtarea.cronogramasP || []).filter(
            (c) => String(c.indicador_id) === String(subtarea.id)
          );

          // 1) meta_ejecutada real con esos P
          const totalAcumulado = cronoP
            .map((c) => parseFloat(c.avance || "0"))
            .reduce((a, b) => a + b, 0);

          // 2) Objeto base de la fila (incluye ids útiles para el render)
          const row = {
            key: `subtarea-${subtarea.id}-1`,
            id: subtarea.id,
            indicador_id: subtarea.id,
            codIndicador: subtarea.id,

            proyecto: selectedProject?.codigo_interno,
            proyecto_oid: actividad.id_acProyecto,
            oidActividad: actividad.id,
            codActividad: actividad.codigo_actividad,
            oidTarea: tarea.id,
            codTarea: tarea.codigo_tarea,

            tarea: `${tarea.codigo_tarea} - ${tarea.descripcion}`,
            indicador: subtarea.indicador,
            meta: subtarea.meta,

            // acumulados
            meta_ejecutada: totalAcumulado,
            metaAcu: totalAcumulado,
            avanceAcu: totalAcumulado,

            pesoPorcentual: tarea.pesoPorcentual,
            fechaInicio: formatDate(subtarea.fecha_inicio),
            fechaFin: formatDate(subtarea.fecha_fin),
            fechaFinReal: formatDate(subtarea.fecha_f_real),

            medioVerificacion:
              subtarea.medios_verificacion?.[0]?.medio_verificacion || "-",
            observacion: subtarea.medios_verificacion?.[0]?.observacion || "-",
            ruta: subtarea.ruta || "-",
            actividad: actividad.descripcion,
            tipo_actividad: subtarea.tipo_actividad,
            actor: subtarea.actor,

            // conserva P filtrados por si el render los necesita
            cronogramasP: cronoP,
          };

          // 3) Celdas por mes SOLO con P del indicador actual.
          //    Acumula si llegan duplicados del mismo mes.
          const mesKeysSet = new Set();
          cronoP.forEach(({ mes, ano, avance }) => {
            const mesKey =
              String(mes).toLowerCase().replace(/\s+/g, "") +
              String(ano).trim();
            const numAvance = parseFloat(avance ?? "0");
            row[mesKey] =
              Number(row[mesKey] || 0) + (isNaN(numAvance) ? 0 : numAvance);
            mesKeysSet.add(mesKey);
          });

          // 4) Flags ✔️ por cada mesKey calculado
          mesKeysSet.forEach((k) => {
            row[`selected_${k}`] = Number(row[k] || 0) >= 0.1;
          });

          return row;
        });
      });
    });
  };

  const procesarMpoa = async (url, valor) => {
    if (url) {
      const Mpoa = url.split("/poa/")[1];

      try {
        const dataCompleta = await fetchPoaData();
        const dataPoa = dataCompleta.dataPoa;
        const findNodePath = (node, path = []) => {
          path.push(node);

          if (node.children && node.children.length > 0) {
            for (let child of node.children) {
              const result = findNodePath(child, [...path]);
              if (result) return result;
            }
          }
          return null;
        };
        let matchedPath = null;

        for (let nodo of dataPoa) {
          matchedPath = findNodePath(nodo);
          if (matchedPath) break;
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    } else {
      setOpenModal1(false);
    }
  };

  const hideModalMedios = () => {
    setBanderaProyecto(null);
    setOpenModal1(false);
    setItemParams(null);
  };

  if (loading) return <div>Cargando ...</div>;

  if (error) {
    return <div>El proyecto no existe o no se encontró información.</div>;
  }

  const formatDateToText = (dateString) => {
    if (!dateString) return ""; // Evita errores si la fecha es nula o indefinida

    // Descomponer la fecha "YYYY-MM-DD"
    const [year, month, day] = dateString.split("-");

    // Crear objeto Date en formato local
    const date = new Date(Number(year), Number(month) - 1, Number(day));

    return date.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const accentColors = ["#FF7043", "#42A5F5", "#26A69A", "#FFCA28"];

  const tabItems = [
    {
      key: "history",
      label: "Historial",
      children: (
        <div>
          <List
            dataSource={historyList}
            renderItem={(item, index) => {
              const fechaCorta = item.fecha_soporte.split("T")[0];

              // Extraigo el texto “medioVerificación” del JSON
              let medioText = "";
              try {
                const parsed = JSON.parse(item.medio_verificacion);
                medioText = parsed.medioVerificacion || "";
              } catch {
                medioText = "";
              }

              return (
                <List.Item
                  actions={[
                    // Sólo incluimos el link “Editar” si permissionExport === true
                    permissionUpdate && (
                      <a
                        key="editar"
                        onClick={() => onEdit(item)}
                        style={{ marginRight: 8 }}
                      >
                        Editar
                      </a>
                    ),

                    // Siempre mostramos el link de “Ver PDF”
                    <a
                      key="descargar"
                      href={item.ruta_soporte}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver PDF
                    </a>,
                  ]
                    // Eliminamos cualquier valor falsy (por ejemplo `false`) antes de renderizar
                    .filter(Boolean)}
                >
                  <List.Item.Meta
                    title={`(${index + 1}) • Avance ${Number(
                      item.avance_pct
                    ).toFixed(1)}% — ${fechaCorta}`}
                    description={medioText}
                  />
                </List.Item>
              );
            }}
          />
          <Button
            type="primary"
            onClick={startNew}
            disabled={!permissionInsert}
            style={{ marginTop: 16 }}
          >
            + Nuevo avance
          </Button>
        </div>
      ),
    },
    {
      key: "form",
      label: isEditing ? "Editar avance" : "Nuevo avance",
      children: (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          size="middle"
          initialValues={{ medioVerificacion: "", soporteName: "" }}
        >
          {/* Campo oculto de observación */}
          <Form.Item name="observacion" hidden>
            <Input />
          </Form.Item>

          {/* Primera fila: Fecha y Avance en la misma línea */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="fecha"
                label="Fecha de realización (dd/mm/aaaa)"
                rules={[{ required: true, message: "La fecha es obligatoria" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  locale={esES}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="avance"
                label="Avance"
                rules={[
                  { required: true, message: "El avance es obligatorio" },
                  {
                    validator: (_, value) => {
                      if (value == null) return Promise.resolve();
                      if (value < 0.1)
                        return Promise.reject(
                          "El avance no puede ser menor que 0.1"
                        );
                      if (value > 100)
                        return Promise.reject(
                          "El avance no puede ser mayor que 100"
                        );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} step={0.1} />
              </Form.Item>
            </Col>
          </Row>

          {/* Segunda fila: 
      - Columna izquierda: Medio de verificación + Nombre del soporte 
      - Columna derecha: Soporte (PDF) */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="medioVerificacion"
                label={
                  <span>
                    Medio de verificación&nbsp;
                    <Tooltip title="Recuerde que los soportes deben ser PDF">
                      <QuestionCircleOutlined
                        style={{ color: "#1890ff", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>
                }
              >
                <Input disabled />
              </Form.Item>

              <Form.Item
                name="soporteName"
                label="Nombre del soporte"
                rules={[
                  {
                    required: true,
                    message: "El nombre del soporte es obligatorio",
                  },
                  {
                    pattern:
                      /^[0-9]{1,4}_[A-Za-z0-9_]+_[0-9]{4}_[0-9]{2}_[0-9]{2}$/,
                    message: "Ej: 1_Acta_Inicio_2025_03_29",
                  },
                ]}
              >
                <Input disabled placeholder="Se generará automáticamente" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item shouldUpdate>
                {() => {
                  const nameErrors = form.getFieldError("soporteName");
                  const nameValue = form.getFieldValue("soporteName");
                  const uploadDisabled = !!nameErrors.length || !nameValue;
                  return (
                    <Form.Item
                      name="soporte"
                      label="Soporte (PDF)"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                      rules={[
                        {
                          required: true,
                          message: "Debe cargar un PDF de soporte",
                        },
                      ]}
                    >
                      <Dragger
                        accept="application/pdf"
                        maxCount={1}
                        disabled={uploadDisabled}
                        beforeUpload={(file) => {
                          const isPdf = file.type === "application/pdf";
                          if (!isPdf) message.error("Solo PDF.");
                          return isPdf ? false : Upload.LIST_IGNORE;
                        }}
                        showUploadList={{ showRemoveIcon: true }}
                      >
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">
                          {uploadDisabled
                            ? "Escriba un nombre válido primero"
                            : "Arrastre o haga clic para seleccionar PDF"}
                        </p>
                      </Dragger>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>

          {/* Tercera fila: Observaciones (ocupa todo el ancho) */}
          <Row>
            <Col span={24}>
              <Form.Item
                name="observaciones"
                label="Observaciones"
                rules={[
                  { required: true, message: "Debe ingresar observaciones" },
                ]}
              >
                <Input.TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>

          {/* Botones de acción */}
          <Form.Item>
            {permissionInsert && (
              <Button
                type="primary"
                htmlType="submit"
                loading={submitting}
                style={{ marginRight: 8 }}
              >
                {isEditing ? "Actualizar" : "Confirmar"}
              </Button>
            )}

            {isEditing && permissionDelete && (
              <Popconfirm
                title="¿Eliminar avance?"
                description="¿Está seguro de que desea eliminar este avance?"
                okText="Sí, eliminar"
                cancelText="Cancelar"
                okButtonProps={{ danger: true }}
                onConfirm={() => onEliminar(current.advance)} // Se ejecuta solo si confirma
              >
                <Button danger style={{ marginRight: 8 }}>
                  Eliminar
                </Button>
              </Popconfirm>
            )}

            <Button onClick={handleCancel}>Cancelar</Button>
          </Form.Item>
        </Form>
      ),
    },
  ];

  // Datos principales a mini-cards
  const info = [
    {
      key: "convenio",
      label: "Convenio",
      value: headerPO?.convenio,
      color: accentColors[0],
    },
    {
      key: "factibilidad",
      label: "Factibilidad",
      value: headerPO?.factibilidad,
      color: accentColors[1],
    },
    {
      key: "ejecutor",
      label: "Ejecutor",
      value: headerPO?.ejecutor,
      color: accentColors[2],
    },
    {
      key: "territorio",
      label: "Grupo territorial",
      value: headerPO?.territorio_zona,
      color: accentColors[3],
    },
  ];

  // Métricas
  const metrics = [
    { key: "dur", label: "Duración", value: headerPO?.duracion },
    {
      key: "ini",
      label: "Fecha Inicio",
      value: formatDateToText(headerPO?.fecha_inicio),
    },
    {
      key: "fin",
      label: "Fecha Terminación",
      value: formatDateToText(headerPO?.fecha_terminacion),
    },
  ];

  const formatFechaToISO = (fecha) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      const [year, month, day] = fecha.split("-");
      const formattedDate = new Date(year, month - 1, day);
      if (isNaN(formattedDate)) {
        throw new Error(`Fecha no válida: ${fecha}`);
      }
      return formattedDate.toISOString();
    }

    // Detecta si la fecha está en formato DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
      const [day, month, year] = fecha.split("/");
      const formattedDate = new Date(year, month - 1, day);
      if (isNaN(formattedDate)) {
        throw new Error(`Fecha no válida: ${fecha}`);
      }
      return formattedDate.toISOString();
    }

    // Si no coincide con ninguno de los formatos, lanza un error
    throw new Error(`Formato de fecha inválido: ${fecha}`);
  };

  const handleNoInfoClick = (datos) => {
    setBanderaProyecto(selectedProject.codigo_interno);
    setActividadSelect(datos);
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setBanderaProyecto(null);
    setActividadSelect(null);
    setIsModalVisible(false);
  };

  const sumarMeses = (record) => {
    const monthKeys = Object.keys(record).filter((key) =>
      key.startsWith("mes")
    );
    return monthKeys.reduce((sum, key) => {
      const val = Number(record[key]) || 0;
      return sum + val;
    }, 0);
  };

  const columnss = [
    ...(isVisibleTarea
      ? [
          {
            title: "Actividades Derivadas",
            dataIndex: "tarea",
            key: "tarea",
            width: 300,
            ellipsis: false,
            // Ya no condicionamos por rowIndex:
            render: (text) => (
              <div
                style={{
                  width: "482px",
                  whiteSpace: "pre-line",
                  wordWrap: "break-word",
                  textAlign: "justify",
                }}
              >
                {text}
              </div>
            ),
          },
        ]
      : []),

    {
      title: "Subactividad",
      dataIndex: "indicador",
      key: "indicador",
      fixed: "left",
      width: 50,
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "300px",
              minWidth: "300px",
              maxWidth: "300px",
              lineHeight: 0.9,
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Tipo",
      dataIndex: "tipo_actividad",
      key: "tipo_actividad",
      width: 150,
      align: "center",
    },
    {
      title: "Actor",
      dataIndex: "actor",
      key: "actor",
      width: 150,
      align: "center",
    },

    {
      title: "Meta",
      dataIndex: "meta",
      key: "meta",
      width: 100,
      fixed: "left",
      align: "center",
      // Sin rowIndex, sin rowSpan:
      render: (value) => {
        const numValue = Number(value);
        if (isNaN(numValue)) return "-";
        const decimalPart = numValue % 1;
        return decimalPart <= 0.1 ? Math.trunc(numValue) : numValue.toFixed(1);
      },
    },

    {
      title: "Meta ejecutada",
      key: "meta_ejecutada",
      width: 150,
      align: "center",
      fixed: "left",
      render: (_text, record) => {
        const metaTotal = Number(record.meta);
        if (isNaN(metaTotal) || metaTotal === 0) {
          return "-";
        }

        // Calculamos la suma de todos los meses
        const ejecutadaReal = sumarMeses(record);

        // Nunca mostrar más que la meta
        const value = ejecutadaReal > metaTotal ? metaTotal : ejecutadaReal;
        const decimalPart = value % 1;
        return decimalPart <= 0.0001
          ? String(Math.trunc(value))
          : value.toFixed(1);
      },
    },

    {
      title: "% avance",
      key: "porcentaje_avance",
      width: 120,
      align: "center",
      render: (_text, record) => {
        const metaTotal = Number(record.meta);
        if (isNaN(metaTotal) || metaTotal === 0) {
          return "-";
        }

        // Volvemos a usar la suma de todos los meses
        const ejecutadaReal = sumarMeses(record);
        const ejecutadaCapped =
          ejecutadaReal > metaTotal ? metaTotal : ejecutadaReal;
        const porcentaje = (ejecutadaCapped / metaTotal) * 100;
        return `${porcentaje.toFixed(1)}%`;
      },
    },

    {
      title: "% acumulado",
      key: "avance_calculado",
      width: 150,
      align: "center",
      render: (_text, record) => {
        const metaNum = Number(record.meta);
        if (isNaN(metaNum) || metaNum === 0) {
          return "-";
        }

        // 1) Buscamos todas las propiedades de record que correspondan a meses:
        const monthKeys = Object.keys(record).filter((key) =>
          key.startsWith("mes")
        );
        //    (Ejemplo: ['mes12025','mes22025','mes32025',…])

        // 2) Sumamos todos los valores numéricos de esos campos.
        const totalEjecutada = monthKeys.reduce((sum, key) => {
          const val = Number(record[key]) || 0;
          return sum + val;
        }, 0);

        // 3) Calculamos % sobre la meta total:
        const porcentaje = (totalEjecutada / metaNum) * 100;
        return `${porcentaje.toFixed(1)}%`;
      },
    },

    ...columnasFinales,
    {
      title: "MEDIO DE VERIFICACIÓN",
      dataIndex: "medioVerificacion",
      key: "medioVerificacion",
      width: 350,
      ellipsis: false,
      // Eliminamos onCell y cualquier condicional:
      render: (text) => (
        <div
          style={{
            width: "450px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",
            textAlign: "justify",
          }}
        >
          {text}
        </div>
      ),
    },

    ...(permissionExport
      ? [
          {
            title: "Ruta Soportes",
            dataIndex: "ruta",
            align: "center",
            key: "ruta",
            width: 150,

            render: (text, record) => {
              if (!text) {
                return (
                  <Tooltip title="No hay información disponible">
                    <InfoCircleOutlined
                      style={{
                        fontSize: 16,
                        color: "#8ABF45",
                        cursor: "pointer",
                      }}
                      onClick={() => handleNoInfoClick(record)}
                    />
                  </Tooltip>
                );
              }

              const contentRegex = /{([^{}]+)}/g;
              const matches = [...text.matchAll(contentRegex)];

              // Si no hay llaves, tratamos al texto completo
              if (matches.length === 0) {
                return text.startsWith("https://") ? (
                  <Tooltip title={text}>
                    <LinkOutlined
                      style={{
                        fontSize: 16,
                        color: "#317EDA",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClickBasedOnURL(text, record)}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={text}>
                    <InfoCircleOutlined
                      style={{
                        fontSize: 16,
                        color: "#8ABF45",
                        cursor: "pointer",
                      }}
                      onClick={() => handleNoInfoClick(record)}
                    />
                  </Tooltip>
                );
              }

              // Si hay varios fragmentos {…}, los mostramos todos
              return (
                <Space>
                  {matches.map((m, idx) => {
                    const content = m[1].trim();
                    return content.startsWith("https://") ? (
                      <Tooltip key={idx} title={content}>
                        <LinkOutlined
                          style={{
                            fontSize: 16,
                            color: "#317EDA",
                            cursor: "pointer",
                          }}
                          onClick={() => handleClickBasedOnURL(content, record)}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip key={idx} title={content}>
                        <InfoCircleOutlined
                          style={{
                            fontSize: 16,
                            color: "#8ABF45",
                            cursor: "pointer",
                          }}
                          onClick={() => handleNoInfoClick(record)}
                        />
                      </Tooltip>
                    );
                  })}
                </Space>
              );
            },
          },
        ]
      : []),
  ];

  const panelItems = actividades.map((actividad) => ({
    key: actividad.codigo_actividad,
    label: (
      <span style={{ color: "#000", marginRight: "8px" }}>
        Actividad: {actividad.codigo_actividad} - {actividad.descripcion}
      </span>
    ),
    style: {
      color: "#000 !important",
      borderBottom: "0.5px solid #aaa",
      boxShadow: "rgb(251 253 255 / 35%) 1px 2px 5px",
      margin: "0px",
    },
    children: (
      <div className="tabla-container">
        {mostrarTablaCronograma && (
          <div className="custom-ant-table-wrapper">
            <Table
              bordered
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              width="100%"
              className="table-curso-fortalecimiento"
              style={{ tableLayout: "fixed", lineHeight: 0.5 }}
              columns={columnss}
              dataSource={tareasSubtareas.filter(
                (tarea) => tarea.oidActividad === actividad.id
              )}
              pagination={false}
              loading={loading}
              scroll={{
                x: "max-content",
                y: 600,
              }}
              size="small"
              rowClassName={(record, index) =>
                index === filaSeleccionada ? "fila-normal" : "fila-normal"
              }
              onRow={(record, index) => ({
                onClick: () => setFilaSeleccionada(index),
              })}
            />
          </div>
        )}
      </div>
    ),
  }));

  // 1) Prepara un dataSource único
  const dataConActividad = actividades.flatMap((actividad) => {
    // busca todas las filas de tareasSubtareas para esta actividad
    const filas = tareasSubtareas.filter(
      (t) => t.oidActividad === actividad.id
    );

    // añade a cada fila un campo `actividadLabel`
    return filas.map((fila) => ({
      ...fila,
      actividadLabel: `Actividad ${actividad.codigo_actividad} – ${actividad.descripcion}`,
    }));
  });

  const columnasUnificadas = [
    ...(isVisibleTarea
      ? [
          {
            title: "Actividad",
            dataIndex: "actividadLabel",
            key: "actividadLabel",
            width: 300,
            ellipsis: false,
            render: (text) => (
              <span style={{ fontWeight: "bold", lineHeight: "1.2 !importan" }}>
                {text}
              </span>
            ),
          },
        ]
      : []),
    ...columnss,
  ];

  const toggleVisibility = (checked) => {
    setIsTableView(checked);

    // ✅ Ejecuta las demás acciones de mostrar/ocultar:
    if (checked) {
      // Código para mostrar la vista de tabla y ocultar cards
      setIsVisible(false); // Cambiar el estado entre visible y oculto
      setIsVisibleTablePO(false);
      setIsVisibleTarea(false);
    } else {
      // Código para mostrar cards y ocultar tabla
      setIsVisible(true); // Cambiar el estado entre visible y oculto
      setIsVisibleTablePO(true);
      setIsVisibleTarea(true);
    }
  };

  const regresar = () => {
    regresarAnterior();
    setEditingDate(false);
    cerrarModal();
  };

  const handleEditDateClick = () => {
    setEditingDate(true);
  };

  const handleDateChange = async (date, dateString, headerPO) => {
    if (date && headerPO) {
      const fecha = dayjs(dateString, "DD/MM/YYYY").format("YYYY-MM-DD");
      const oid = headerPO?.children?.[0]?.id;
      const tipo = "detalle";
      const updatedHeaderPO = { ...headerPO };
      updatedHeaderPO.fecha_actualizacion = formatFechaToISO(fecha);
      if (updatedHeaderPO.children && updatedHeaderPO.children.length > 0) {
        updatedHeaderPO.children[0].fecha_actualizacion =
          formatFechaToISO(fecha);
      }
      try {
        await updateFecha(oid, fecha, tipo);
        setHeaderPO(updatedHeaderPO);
        setEditingDate(false);
        message.success("Fecha actualizada correctamente");
      } catch (error) {
        message.error("Hubo un error al actualizar la fecha");
        console.error("Error al actualizar la fecha:", error);
      }
    }
  };

  return (
    <Layout>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          gap: "10px",
          marginRight: "30px",
          borderBottom: "0.5px solid #aaa",
          paddingBottom: "5px",
          marginTop: "-7px",
        }}
      >
        {/* ← Columna 1: Título */}
        <div className="d-flex align-items-center">
          <Title level={3} style={{ lineHeight: 1, margin: 0 }}>
            Plan Operativo Anual (POA)
          </Title>
        </div>

        {/* ← Columna 2: solo si !isVisible */}
        {!isVisible && (
          <div className="d-flex align-items-center gap-2 py-2">
            {/* Código – implementador */}
            <h5
              className="mb-0 gradient-text"
              style={{
                color: "#1677ff",
                fontSize: "1.2rem",
                margin: 0,
                lineHeight: 1,
              }}
            >
              {selectedProject.codigo_interno} – {selectedProject.implementador}
              :
            </h5>

            {/* Contenedor de fecha */}
            <div
              className="d-flex align-items-center gap-2"
              style={{
                minWidth: "180px",
                cursor: permissionInsert ? "pointer" : "not-allowed",
              }}
              onClick={permissionInsert ? handleEditDateClick : undefined}
            >
              {editingDate ? (
                <input
                  type="date"
                  className="form-control form-control-sm border-0 p-0 text-end"
                  value={
                    headerPO?.fecha_actualizacion
                      ? moment(headerPO.fecha_actualizacion).format(
                          "YYYY-MM-DD"
                        )
                      : ""
                  }
                  onChange={(e) =>
                    handleDateChange(
                      e.target.value &&
                        moment(e.target.value, "YYYY-MM-DD").toDate(),
                      e.target.value,
                      headerPO
                    )
                  }
                  autoFocus
                />
              ) : headerPO?.fecha_actualizacion ? (
                <span
                  className="flex-grow-1 text-end"
                  style={{ fontSize: "0.9rem", color: "#575757", margin: 0 }}
                >
                  {moment(headerPO.fecha_actualizacion).format("DD/MM/YYYY")}
                </span>
              ) : (
                <div
                  className="d-flex align-items-center flex-grow-1"
                  style={{
                    justifyContent: "center",
                    gap: "8px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    padding: "8px 12px",
                  }}
                >
                  <span className="text-muted small" style={{ margin: 0 }}>
                    Haz clic para registrar la fecha
                  </span>
                  <Tooltip title="*Por favor diligenciar este campo, con la fecha de corte...">
                    <WarningOutlined
                      style={{
                        fontSize: "20px",
                        color: "red",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              )}

              {/* Etiqueta al lado derecho */}
              <div className="text-secondary small mb-0">
                Fecha de actualización
              </div>
            </div>
          </div>
        )}

        {/* ← Columna 3: Botones */}
        <div className="d-flex align-items-center gap-2">
          <Tooltip title="Regresar">
            <Button
              type="primary"
              shape="circle"
              icon={<ArrowLeftOutlined />}
              onClick={regresar}
              style={{ marginRight: "8px" }}
            />
          </Tooltip>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Switch
              checked={isTableView}
              onChange={(checked) => toggleVisibility(checked)}
              checkedChildren="Compacto"
              unCheckedChildren="Extendido"
              style={{ marginLeft: 16 }}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex justify-content-left"
        style={{ marginRight: "30px", gap: "10px" }}
      >
        {isVisible && (
          <>
            <div style={{ background: "#fff", padding: "0px 0px 20px 0px" }}>
              {/* Grid de mini-cards */}
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                {info.map((item, idx) => (
                  <Col xs={24} sm={12} md={6} key={item.key}>
                    <Card
                      hoverable
                      style={{
                        padding: 16,
                        borderRadius: 8,
                        background: "#FFFFFF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        position: "relative",
                        maxWidth: 230,
                        overflow: "hidden",
                        width: 230,
                      }}
                    >
                      {/* Badge de color */}
                      <div
                        style={{
                          position: "absolute",
                          top: 16,
                          left: 16,
                          backgroundColor: item.color,
                          color: "#fff",
                          padding: "4px 8px",
                          borderRadius: 4,
                          fontWeight: "bold",
                          fontSize: "0.875rem",
                        }}
                      >
                        {item.label.charAt(0)}
                        {/* p.ej. "C" para Convenio */}
                      </div>

                      {/* Espacio para que no se solape el badge */}
                      <div style={{ height: 32 }} />

                      {/* Texto */}
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {item.label}
                      </Text>
                      <br />
                      <Text
                        style={{ fontSize: 16, fontWeight: 500 }}
                        ellipsis={{ tooltip: item.value }} // trunca con "..." y muestra todo en tooltip
                      >
                        {item.value || "-"}
                      </Text>
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* Badges de métricas */}
              <Row gutter={16} style={{ marginTop: 24 }}>
                {metrics.map((m, i) => (
                  <Col key={m.key}>
                    <Tag
                      color={accentColors[i % accentColors.length]}
                      style={{ padding: "8px 16px", fontSize: 14 }}
                    >
                      {m.label}: {m.value || "-"}
                    </Tag>
                  </Col>
                ))}
              </Row>
            </div>

            <div
              className="cardFecha"
              style={{
                marginTop: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <Title
                level={4}
                className="gradient-text"
                style={{
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  lineHeight: 0.9,
                  color: "#1677ff",
                }}
              >
                {selectedProject.codigo_interno} -{" "}
                {selectedProject.implementador}
              </Title>

              <Text type="secondary" style={{ fontSize: 12 }}>
                Fecha de actualización:
              </Text>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  border: "1px solid #A19E9E",
                  fontWeight: "bold",
                  padding: "5px",
                  borderRadius: "4px",
                  margin: 0,
                  width: "auto",
                  cursor: permissionInsert ? "pointer" : "not-allowed",
                  backgroundColor: permissionInsert ? "white" : "#f8f9fa",
                }}
                onClick={() => {
                  if (permissionInsert) {
                    handleEditDateClick();
                  }
                }}
              >
                {editingDate ? (
                  <DatePicker
                    style={{ width: "270px" }}
                    onChange={(date, dateString) =>
                      handleDateChange(date, dateString, headerPO)
                    }
                    value={
                      headerPO?.fecha_actualizacion
                        ? dayjs(headerPO.fecha_actualizacion)
                        : null
                    }
                    format="DD/MM/YYYY"
                  />
                ) : headerPO?.fecha_actualizacion ? (
                  // Este span ahora lleva ms-auto para empujarlo a la derecha
                  <span
                    className="ms-auto"
                    style={{ fontSize: "0.9rem", color: "#575757" }}
                  >
                    {moment(headerPO.fecha_actualizacion).format("DD/MM/YYYY")}
                  </span>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      padding: "8px 12px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      textAlign: "right",
                    }}
                  >
                    <span
                      style={{
                        color: "#575757",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      Haz clic para registrar la fecha
                    </span>
                    <Tooltip title="*Por favor diligenciar este campo...">
                      <WarningOutlined
                        style={{
                          fontSize: "20px",
                          color: "red",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>

              {headerPO?.fecha_actualizacion ? null : (
                <Tooltip title="**Por favor diligenciar este campo, con la fecha de corte en la que se actualizaron las metas ejecutadas del POA.">
                  <WarningOutlined
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              )}
            </div>
          </>
        )}
      </div>

      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Tooltip title={`Fase ${selectedFase.nombre_largo}`}>
            <Title
              level={5}
              className="justified-title"
              style={{
                marginTop: "10px",
                marginRight: "16px",
                cursor: "pointer",
              }} // separa el título del icono
            >
              {selectedFase.nombre_corto}
            </Title>
          </Tooltip>

          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              onClick={toggleVisibilityTarea}
              style={{
                color: "red",
                cursor: "pointer",
                fontSize: "20px",
                marginRight: "16px",
              }} // aumenta el tamaño del icono
            >
              <Tooltip title={`Mostrar u ocultar la columna.`}>
                <ColumnHeightOutlined
                  style={{
                    color: toggleVisibilityTarea ? "green" : "gray",
                    fontSize: "20px",
                  }}
                />
              </Tooltip>
            </span>

            <span
              onClick={toggleVisibilityTablaPO}
              style={{
                color: "red",
                cursor: "pointer",
                fontSize: "20px",
                marginRight: "16px",
              }} // aumenta el tamaño del icono
            >
              <Tooltip title={`Cambiar tipo de vista.`}>
                <VerticalAlignMiddleOutlined
                  style={{
                    color: toggleVisibilityTablaPO ? "green" : "gray",
                    fontSize: "20px",
                  }}
                />
              </Tooltip>
            </span>
          </div>
        </div>

        {isVisibleTablePO && (
          <Collapse
            accordion
            items={panelItems}
            className="collapseIco collapseIcoPanel"
          />
        )}

        {!isVisibleTablePO && (
          <div
            style={{
              marginTop: "0px",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <Table
              bordered
              components={{ body: { cell: EditableCell } }}
              style={{ tableLayout: "fixed" }}
              columns={columnasUnificadas}
              dataSource={dataConActividad}
              pagination={false}
              loading={loading}
              scroll={{ x: "max-content", y: 600 }}
              size="small"
              rowKey={(record) => record.key} // o el campo que uses como key
              rowClassName={(record, index) =>
                index === filaSeleccionada ? "fila-seleccionada" : "fila-normal"
              }
              onRow={(record, index) => ({
                onClick: () => setFilaSeleccionada(index),
              })}
            />
          </div>
        )}
      </div>

      <Modal
        title="Avances del mes"
        open={modalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
        style={{ top: 20 }}
        destroyOnClose
      >
        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            if (key === "form" && !isEditing) startNew();
          }}
          destroyInactiveTabPane // ← esto unmount/remount al cambiar de tab
          items={tabItems}
        />
      </Modal>

      <div className="d-flex justify-content-center">
        <Modal
          title={
            <span className="custom-modal-title">Medios de verificación</span>
          }
          open={isModalVisible}
          onCancel={hideModal}
          footer={null}
          width="95%"
          style={{ top: 20 }}
          destroyOnClose
        >
          <FileManagerPOA2
            codigo_tarea={actividadSelect}
            select_proyect={banderaProyecto}
          />
        </Modal>
      </div>

      <div className="d-flex justify-content-center">
        <Modal
          title={
            <span className="custom-modal-title">Medios de verificación</span>
          }
          open={openModal1}
          onCancel={hideModalMedios}
          footer={null}
          width="95%"
          style={{ top: 20, height: "95vh" }}
          destroyOnClose
          contentStyle={{
            maxHeight: "calc(100vh - 20px - 55px)", // 20px de top + ~55px de header
            overflowY: "auto",
          }}
        >
          <FileManagerPOAN codigo_tarea={itemParams} />
        </Modal>
      </div>
      <div>
        <Modal
          title=""
          open={isModalVisibleParticipantes}
          onCancel={handleCancelParticipantes}
          footer={null}
          width="95%"
          style={{ top: 10 }}
          destroyOnClose
        >
          {/*renderComponent()*/}
        </Modal>
      </div>
    </Layout>
  );
};

export default PoaPlanOperativoTB;
